export default "__VITE_ASSET__Db5NT_Lv__"